<section
  [attr.data-testid]="sectionTestId()"
  [ngClass]="{
    'mr-large-b': text() && layoutVariant() !== 'section-two-thirds-right',
    'mr-xlarge-b': text() && layoutVariant() !== 'section-full-width',
    'col-1-12': isFullWidth(),
  }"
>
  @if (image()) {
    <div
      class="image-container"
      [ngClass]="{
        'pr-large-b':
          layoutVariant() === 'section-two-thirds-right' &&
          !subjectTaxonomyTags().includes('cmstyle-image-container-no-padding'),
        'pr-small-b': layoutVariant() !== 'section-two-thirds-right',
      }"
    >
      <cms-text-on-image [content$]="content() | finToObservable" [noText]="true" />
    </div>
  }

  @if (title(); as t) {
    @switch (headerLevel()) {
      @case (1) {
        <h1 class="teaser-title" [class.pr-clear-b]="icon()">{{ t }}</h1>
      }
      @case (3) {
        <h3 class="teaser-title" [class.pr-clear-b]="icon()">{{ t }}</h3>
      }
      @case (4) {
        <h4 class="teaser-title" [class.pr-clear-b]="icon()">{{ t }}</h4>
      }
      @default {
        <h2 class="teaser-title" [class.pr-clear-b]="icon()">{{ t }}</h2>
      }
    }
  }

  @if (icon(); as i) {
    <div class="teaser-icon-container">
      <img [src]="i" [alt]="title() | finEmpty" class="grow" />
    </div>
  }

  <div
    class="teaser-text"
    [ngClass]="{
      'mr-xxlarge-b': layoutVariant() === 'section-two-thirds-right',
      'mr-large-b': layoutVariant() !== 'section-two-thirds-right',
    }"
    [innerHTML]="text() | finSafe: 'html'"
  ></div>

  @if (ingredients()) {
    <div class="teaser-text ingredients" [innerHTML]="ingredients() | finSafe: 'html'"></div>
  }
</section>
